import React from 'react';
import { Typography } from '@heycater/design-system';
import Image from 'next/image';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import FlexBox from 'shared/components/FlexBox';
import Container from 'system/components/Container';

function BenefitsSection() {
  const { t } = useTranslation('dynamic_landing_page');
  return (
    <Container as="section" size="md">
      <Wrapper position="relative" alignItems="center" py={4} gap={4}>
        <ImageWrapper>
          <Image
            alt=""
            height={887}
            width={1076}
            layout="responsive"
            src="/artifacts/images/marketing_pages/benefits_img.webp"
          />
        </ImageWrapper>
        <FlexBox py={{ xs: 0, md: 3 }} gap={3} flexDirection="column">
          <TypographySectionTitle
            px={2}
            textAlign="center"
            variant="h3"
            fontSize="24px"
          >
            {t('common:benefits.title.part1')}
            <br />
            {t('common:benefits.title.part2')}
          </TypographySectionTitle>
          <BenefitsGrid />
        </FlexBox>
      </Wrapper>
    </Container>
  );
}

const Wrapper = styled(Container)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)}px;
  padding: ${({ theme }) => theme.spacing(4, 0)};
  flex-direction: column;

  ${({ theme }) => theme.breakpoints.up('md')} {
    flex-direction: row;
    gap: ${({ theme }) => theme.spacing(6)}px;
  }
`;

const ImageWrapper = styled.div`
  position: relative;
  flex-grow: 1;
  max-width: 300px;
  width: 100%;

  ${({ theme }) => theme.breakpoints.up('md')} {
    width: 600px;
    max-width: none;
  }
`;

const BenefitsGrid = styled.ul`
  list-style: none;
  padding: 0;
  display: grid;
  grid-column-gap: ${({ theme }) => theme.spacing(3)}px;
  grid-row-gap: ${({ theme }) => theme.spacing(4)}px;
  grid-template-columns: 1fr 1fr;
  justify-items: center;
  align-items: start;

  ${({ theme }) => theme.breakpoints.up('sm')} {
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: ${({ theme }) => theme.spacing(8)}px;
    grid-row-gap: ${({ theme }) => theme.spacing(2)}px;
  }
  ${({ theme }) => theme.breakpoints.up('md')} {
    grid-column-gap: ${({ theme }) => theme.spacing(3)}px;
  }
`;

const TypographySectionTitle = styled(Typography)`
  font-size: 18px;
  line-height: 160%;

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 24px;
  }
`;

export default BenefitsSection;
